import { Button } from '../Button';
import { ButtonId } from '../../enum/ButtonId';
import * as Theme from '../../Theme';

export type TabButtonParams = {
  id: string;
  text: string;
  width?: number;
  height?: number;
  fontSize?: number;
};

export function TabButton(params: TabButtonParams) {
  const width = params.width ?? 130;
  const height = params.height ?? 68;
  return Button({
    id: params.id,
    width,
    height,
    titleWidth: width * 0.8,
    title: params.text,
    fontName: Theme.fontMainBold.name,
    titleFontSize: params.fontSize ?? 28,
    letterSpacing: -0.08,
    backgroundColor: '#FFFFFF',
    backgroundOpacity: 0,
    hoverColor: '#FFFFFF',
    hoverOpacity: 0.2,
    activeColor: '#FFFFFF',
    activeOpacity: 0.1,
    fontColor: '#DDDDDD',
    fontColorHover: '#FFFFFF',
    fontColorActive: '#FFFFFF',
    borderRadius: 24,
    selected: true,
  });
}
